export const translation = {
    he: {
      'Approve': 'אשר',
      'Sign in': 'כניסה',
      'Sign Out': 'יציאה',
      'Create Account': "צור חשבון",
      'Email': 'אימייל',
      'Password': 'סיסמא',
      'Confirm Password': 'אימות סיסמא',
      'Enter your Password': 'הכנס את הסיסמא',
      'Enter your Email': 'הכנס את האימייל',
      'Please confirm your Password': 'אנא אמת את הסיסמא',
      'Forgot your password?': 'שכחת את הסיסמא?',
      'Token': 'טוקן',
      'We Emailed You': 'שלחנו לך אימייל',
      'An account with the given email already exists.': 'חשבון עם האימייל הזה כבר קיים',
      'Reset Password': 'איפוס סיסמא',
      'Enter your code': 'הכנס את הקוד',
      'Enter your email': 'הכנס את האימייל',
      'Send Code': 'שלח קוד',
      'Send code': 'שלח קוד',
      'Confirm': 'אימות',
      'Back to Sign In': 'חזרה לכניסה',
      'Password must have at least 8 characters': 'הסיסמא חייבת להכיל לפחות 8 תווים',
      'Your password is weak': 'הסיסמא חלשה',
      'Your password is strong': 'הסיסמא חזקה',
      'Your passwords must match': 'הסיסמאות חייבות להתאים',
      'Cannot reset password for the user as there is no registered/verified email or phone_number': 'לא ניתן לאפס את הסיסמא עבור המשתמש כיוון שאין אימייל או מספר טלפון רשום/מאומת',
      'Username/client id combination not found.': 'שם משתמש/קוד לא נמצא',
      'User does not exist.': 'המשתמש לא קיים',
      'Your code is on the way. To log in, enter the code we emailed to': 'הקוד שלך בדרך. כדי להתחבר, הכנס את הקוד ששלחנו ל',
      'It may take a minute to arrive' : 'יכול לקחת דקה להגיע',
      'Confirmation Code': 'קוד אימות',
      'Resend Code': 'שלח קוד שוב',
      'Invalid verification code provided, please try again': 'קוד אימות שגוי, אנא נסה שוב',
      'Buy Tokens': 'קנה טוקנים',
      'Setup Subscription': 'הגדר מנוי',
      'Left': 'נותרו',
      'There is a balance due': 'קימת יתרה לתשלום',
      'Pay Now': 'שלם עכשיו',
      'There is no balance due': 'אין יתרה לתשלום',
      'Open Payments': 'רכישות פתוחות',
      'open': 'פתוח',
      'closed': 'סגור',
      'Status': 'סטטוס',
      'Document Number': 'מספר מסמך',
      'Type': 'סוג',
      'Date': 'תאריך',
      'Amount': 'סכום',
      'Account': 'חשבון',
      'Price': 'מחיר',
      'Price Including Tax': 'מחיר כולל מע"מ',
      'TopUp': 'טופ אפ',
      'topUp': 'טופ אפ',
      'Subscription': 'מנוי',
      'subscription': 'מנוי',
      'Change Token Type': 'שנה סוג טוקן',
      'Current Token Type': 'סוג טוקן נוכחי',
      'Save': 'שמור',
      'Click here to pay now, and setup monthly subscription': 'לחץ כאן כדי לשלם עכשיו ולהגדיר מנוי חודשי',
      'Per Month': 'לחודש',
      'NIS': '₪',
      'Subscription Price': 'עלות מנוי',
      'TopUp Price': 'עלות טופ אפ',
      'Other Documents': 'מסמכים אחרים',
      'Per Invoice': 'לחשבונית',
      'Parse Invoice': 'פענוח חשבונית',
      'Monthly Subscription Price': 'עלות מנוי חודשי',
      'Choose Token Type': 'בחר סוג טוקן',
      'Note: If the API is not in use, there will be no monthly fee.': 'הערה: אם ה-API אינו בשימוש, לא תחוייב בעלות חודשית.',
      'Prices do not include VAT': 'המחירים לא כוללים מע"מ',
      'Path': 'נתיב',
      'Please add payment methods': 'אנא הוסף אמצעי תשלום',
      'No Payment Method': 'אין אמצעי תשלום',
      'Payment Methods': 'אמצעי תשלום',
      'Expire' : 'תוקף',
      'to buy new tokens': 'לקנות טוקנים חדשים',
      'Your token quota is over, to continue scanning you have': 'מכסת הטוקנים שלך הסתיימה, להמשך הסריקה יש',
      "Please pay now to start scanning": "אנא שלם עכשיו כדי להתחיל לסרוק",
      "Subscription charge for remaining days of month": "תשלום המנוי עבור ימים שנותרו בחודש",
      "Charge for scan": "תשלום עבור סריקה",
      'Scan': 'סריקה',
      "The payment is awaiting approval from the credit company": "התשלום ממתין לאישור מחברת האשראי",
      'Segments': 'קטעים',
      'Document': 'מסמך',
      'Chat with AI': 'דבר עם AI',
      'Tables': 'טבלאות',
      'Key/Value': 'Key/Value',
      'Drag an Image/PDF file containing a document here\.': '{{"Drag an Image/PDF file containing a document here\." | i18n}}',
      // '': '{{"Drag an Image/PDF file containing a document here\." | i18n}}',
      // '': '{{"Drag an Image/PDF file containing a document here\." | i18n}}',
    },

  };